<template>
  <HomeCard v-if="user">
    <CardHeader title="Trạng thái sử dụng trong ngày" icon="fas fa-bolt" />
    <br />
    <el-row>
      <el-col :span="12">
        <NumberInfo label="lượt kiểm tra còn lại" :number="user.credit.checkAttempt"/>
      </el-col>
      <el-col :span="12">
        <NumberInfo label="trang kiểm tra còn lại" :number="user.credit.credit"/>
      </el-col>
    </el-row>
    <br/>
    <div>
      <el-alert title="Trong trường hợp sử dụng hết số lượt, tài khoản sẽ được cộng thêm 1 lượt kiểm tra sau 3 ngày kể từ thời điểm hết lượt." type="info" show-icon />
    </div>
  </HomeCard>
</template>

<script>
import { mapState } from "vuex"
import { AUTHENTICATE_STORE } from "@/store/modules/AuthenticateStore.js"
import VePie from "v-charts/lib/pie.common"
import CardHeader from "@/components/HomeComponents/CardHeader.vue"
import HomeCard from "@/components/HomeComponents/HomeCard.vue"
import NumberInfo from "@/components/HomeComponents/NumberInfo.vue"
export default {
  name: "CreditStatusCard",
  components: { NumberInfo, HomeCard, CardHeader, VePie },
  computed: {
    ...mapState({
      user: (state) => state[AUTHENTICATE_STORE].user,
    })
  },
}
</script>
<style lang="scss" scoped></style>
